import { render, staticRenderFns } from "./CreateSubFolder.vue?vue&type=template&id=5df8a4ba&"
import script from "./CreateSubFolder.vue?vue&type=script&lang=js&"
export * from "./CreateSubFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports